import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FileDialogButtonView from '@ckeditor/ckeditor5-ui/src/button/filedialogbuttonview';
import { createFileTypeRegExp } from './utils';
// import fileUploadIcon from './theme/icons/file-upload.svg';

/**
 * The file upload button plugin.
 *
 * Adds the `'fileUpload'` button to the {@link module:ui/componentfactory~ComponentFactory UI component factory}.
 *
 * @extends module:core/plugin~Plugin
 */
export default class FileUploadUI extends Plugin {
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'FileUploadUI';
    }

	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;
		const t = editor.t;

        const toolbarComponentCreator = () => {
            const button = this._createButton(FileDialogButtonView);
            button.set({
                label: t('Upload file from computer'),
                tooltip: true
            });
            return button;
        };
        // Setup `uploadFile` button
        editor.ui.componentFactory.add('uploadFile', toolbarComponentCreator);
	}

    /**
     * Creates a button for image upload command to use either in toolbar or in menu bar.
     */
    _createButton(ButtonClass) {
        const editor = this.editor;
        const locale = editor.locale;
        const t = locale.t;
        const command = editor.commands.get('uploadFile');
        const acceptedTypes = editor.config.get('fileupload.upload.types');
        const acceptedTypesRegExp = createFileTypeRegExp(acceptedTypes);
        const view = new ButtonClass(locale);
        view.set({
            acceptedType: acceptedTypes.join(','),
            label: t('Upload file from computer'),
            // dá erro se utilizar a referencia ao icon: import fileUploadIcon from './theme/icons/file-upload.svg';
            // icon: fileUploadIcon
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13,20H6a1,1,0,0,1-1-1V5A1,1,0,0,1,6,4h5V7a3,3,0,0,0,3,3h3v2a1,1,0,0,0,2,0V9s0,0,0-.06a1.31,1.31,0,0,0-.06-.27l0-.09a1.07,1.07,0,0,0-.19-.28h0l-6-6h0a1.07,1.07,0,0,0-.28-.19.32.32,0,0,0-.09,0A.88.88,0,0,0,12.05,2H6A3,3,0,0,0,3,5V19a3,3,0,0,0,3,3h7a1,1,0,0,0,0-2ZM13,5.41,15.59,8H14a1,1,0,0,1-1-1ZM8,8a1,1,0,0,0,0,2H9A1,1,0,0,0,9,8Zm6,4H8a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Zm6.71,5.29-2-2a1,1,0,0,0-.33-.21,1,1,0,0,0-.76,0,1,1,0,0,0-.33.21l-2,2a1,1,0,0,0,1.42,1.42l.29-.3V21a1,1,0,0,0,2,0V18.41l.29.3a1,1,0,0,0,1.42,0A1,1,0,0,0,20.71,17.29ZM12,18a1,1,0,0,0,0-2H8a1,1,0,0,0,0,2Z"/></svg>',
            allowMultipleFiles: false,
        });
        view.bind('isEnabled').to(command);
        view.on('done', (evt, files) => {
            const filesToUpload = Array.from(files).filter(file => acceptedTypesRegExp.test(file.type));
            if (filesToUpload.length) {
                editor.execute('uploadFile', { file: filesToUpload });
                editor.editing.view.focus();
            }
        });
        return view;
    }
}